/* src/app/shared/garmin-record/garmin-record.component.scss */
.watchFace {
  width: 50vw;
  height: 50vw;
  background-color: black;
  color: white;
  border-radius: 50%;
  pointer-events: none;
  text-align: center;
  padding-top: 18vw;
  font-size: x-large;
}
span {
  font-size: xx-large;
  font-weight: bold;
}
.ribbonLeft {
  width: 1.5vw;
  height: 9vw;
  border-left: 1vw solid white;
  border-right: 1vw solid white;
  box-sizing: content-box;
  transform: rotate(30deg);
  position: absolute;
  left: 27vw;
  top: -1vw;
}
.ribbonRight {
  width: 1.5vw;
  height: 9vw;
  border-left: 1vw solid white;
  border-right: 1vw solid white;
  box-sizing: content-box;
  transform: rotate(-30deg);
  position: absolute;
  right: 27vw;
  top: -1vw;
}
.medal {
  width: inherit;
  text-align: center;
  position: absolute;
  top: 1vw;
  margin: auto;
  border-radius: 50%;
  overflow: hidden;
  height: 50vw;
}
.star {
  border-radius: 50%;
  margin-top: 6vw;
  width: min-content;
  border: 0.1vw solid black;
  height: min-content;
  font-size: x-large;
  position: relative;
  display: inline-flex;
}
.run,
.virtualrun,
.yoga {
  background: orange;
}
.walk,
.snowshoe,
.golf,
.soccer {
  background: lime;
}
.ride,
.virtualride,
.velomobile,
.ebikeride,
.handcycle,
.wheelchair {
  background: green;
}
.swim,
.kitesurf,
.sail,
.surfing,
.windsurf {
  background: rgb(88, 166, 255);
}
.workout,
.weighttraining,
.hike,
.elliptical,
.crossfit {
  background: rgb(255, 81, 81);
}
.elliptical,
.rowing,
.stairstepper,
.standuppaddling {
  background: darkred;
}
.canoeing,
.kayaking {
  background: rgb(0, 0, 80);
}
.rockclimbing,
.hike {
  background: rgb(194, 110, 0);
}
.alpineski,
.backcountryski,
.snowboard,
.nordicski,
.rollerski,
.iceskate,
.inlineskate,
.skateboard {
  background: gray;
}
/*# sourceMappingURL=garmin-record.component.css.map */
